import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getProductCategories() {
    const response = await axiosPrivate.get('/v3/pharmacist/products/categories');

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async updateProductQuestionnaireId(productId, questionnaireId) {
    const response = await axiosPrivate.put(`/v3/support/products/${productId}/questionnaire-id`, {
      questionnaireId,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async updateProductRrp(productId, recommendedRetailPrice) {
    const response = await axiosPrivate.put(`/v3/support/products/${productId}/rrp`, {
      recommendedRetailPrice,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};

